import React, { useState, useEffect, useContext, useCallback, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import CallIcon from '@mui/icons-material/Call';
import { BsDot } from 'react-icons/bs';
import Rating from '@mui/material/Rating';
import { monthsShort } from '../../common/utils';
import { ListsModal } from '../../contexts';
import LogComms from '../Modals/LogComms';
import { launchPhoneBurner } from '../../common/utils';
import { update } from '../../common/api';
import AddTaskFollowUp from '../Modals/AddTaskFollowUp';


const Call = ( { orgId, aid, uid, obj, meta, gifts, tasks, reviews, loans, notes, comms, opps, gameplan } ) => {
    const [ layout, setLayout ] = useState( [] );
    const [ phones, setPhones ] = useState( [] );
    const [ quicklinks, setQuicklinks ] = useState( [] );
    const [ lastknown, setLastknown ] = useState( [] );
    const [ purchintake, setPurchintake ] = useState( [] );
    const [ latestGift, setLatestGift ] = useState( {} );
    const [ hasGift, setHasGift ] = useState( false );
    const [ latestReview, setLatestReview ] = useState( {} );
    const [ hasReview, setHasReview ] = useState( false );
    const [ latestNote, setLatestNote ] = useState( {} );
    const [ hasNote, setHasNote ] = useState( false );
    const [ latestComm, setLatestComm ] = useState( {} );
    const [ hasComm, setHasComm ] = useState( false );
    const [ latestTask, setLatestTask ] = useState( {} );
    const [ hasTask, setHasTask ] = useState( false );
    const [ latestLoan, setLatestLoan ] = useState( {} );
    const [ hasLoan, setHasLoan ] = useState( false );
    const [ latestOpp, setLatestOpp ] = useState( {} );
    const [ hasOpp, setHasOpp ] = useState( false );
    const [ titleHeight, setTitleHeight ] = useState( 0 );

    const { openModal, closeModal, setModal } = useContext( ListsModal );

    const formatDate = ( d ) => {
        if ( d ) {
            const [ yr, mon, dd ] = d.replace( /[T\s].*/, '' ).split( '-' );
            return `${monthsShort[parseInt(mon) - 1]} ${dd}, ${yr}`;
        }
        return '';
    }

    const markComplete = async ( oid ) => {
        const objType = ( oid.match( /^gp/ ) ) ? 'gameplan' : 'task';
        const cd = new Date();
        const updated = await update( orgId, aid, uid, objType, oid, { status: 'Completed', completedDate: cd.toJSON() } );
        if ( updated.length ) {
            handleSingleModal( 'follow-up-task', oid );
        }
    }

    const taskToCopy = ( oid ) => {
        let t = {};
        if ( oid.match( /^task/ ) ) {
            console.log( 'task: ', tasks[oid] );
            t = {
                details: tasks[oid],
                associations: tasks[oid].assoc
            }
        } else {
            const gp = gameplan[oid];

            t['details'] = {
                name: 'Follow-up on: ' + gp.reason,
                // details: '',
                priority: 'Normal',
                assignedTo: gp.assignedTo,
                type: 'Call'
            };
            t['associations'] = [ { cid: gp.cid } ]
        }
        return t;
    }

    const handleSingleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'log-call':
                console.log( 'log-call w/ cid: ' + obj.c.cid );
                setModal( <LogComms commType='Call' close={closeModal} cid={obj.c.cid} oid={obj.oid} onSave={markComplete} /> );
                break;

            case 'log-email':
                console.log( 'log-email w/ cid: ' + obj.c.cid );
                setModal( <LogComms commType='Email' close={closeModal} cid={obj.c.cid} oid={obj.oid} onSave={markComplete} /> );
                break;

            case 'log-sms':
                console.log( 'log-sms w/ cid: ' + obj.c.cid );
                setModal( <LogComms commType='Txt' close={closeModal} cid={obj.c.cid} oid={obj.oid} onSave={markComplete} /> );
                break;

            case 'follow-up-task':
                const task = taskToCopy( obj.oid );
                console.log( 'follow-up-task w/ oid: ' + obj.oid );
                console.log( 'copy task: ', task );
                setModal( <AddTaskFollowUp close={closeModal} copy={task} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'unknown modeal type for single: ' + t + ' - ' + obj.c.cid )  ;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const titleRef = useCallback( node => {
        if ( node !== null ) {
            setTitleHeight( node.getBoundingClientRect().height );
        }
      }, [] );

    useEffect( () => {
        if ( meta ) {
            console.log( 'meta: ', meta );
            let layout = meta.default;

            if ( meta.key && meta[obj.c[meta.key]] ) {
                layout = meta[obj.c[meta.key]];
            }

            setLayout( layout );
        }
    }, [ meta, obj.c ] );

    useEffect( () => {
        if ( layout ) {
            const setP = new Set();
            const setQL = new Set();
            const setLK = new Set();
            const setPI = new Set();

            layout.forEach( l => {
                l.body.forEach( b => {
                    const p = b.filter( f => f.group === 'phones' );
                    const ql = b.filter( f => f.group === 'quicklink' );
                    const lk = b.filter( f => f.group === 'lastknown' );
                    const pi = b.filter( f => f.group === 'purchintake' );

                    p.forEach( f => setP.add( f ) );
                    ql.forEach( f => setQL.add( f ) );
                    lk.forEach( f => setLK.add( f ) );
                    pi.forEach( f => setPI.add( f ) );
                } );
            } );

            setPhones( [ ...setP ] );
            setQuicklinks( [ ...setQL ] );
            setLastknown( [ ...setLK ] );
            setPurchintake( [ ...setPI] );
        }
    }, [ layout ] );

    // Latest Comm
    useEffect( () => {
        setLatestComm( {} );
        setHasComm( false );

        let list = [];
        Object.keys( comms ).forEach( c => {
            const yes = comms[c]?.assoc?.find( f => f && f.cid === obj.c.cid );
            if ( yes ) {
                list.push( comms[c] );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                const ad = new Date( a.createdDate );
                const bd = new Date( b.createdDate );

                return ( bd.getTime() - ad.getTime() );
            } );
            setLatestComm( list[0] );
            setHasComm( true );
        } 
    }, [ obj.c, comms ] );

    // Latest Note
    useEffect( () => {
        setLatestNote( {} );
        setHasNote( false );

        let list = [];
        Object.keys( notes ).forEach( n => {
            const yes = notes[n]?.assoc?.find( f => f && f.cid === obj.c.cid );
            if ( yes ) {
                list.push( notes[n] );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                const ad = new Date( a.createdDate );
                const bd = new Date( b.createdDate );

                return ( bd.getTime() - ad.getTime() );
            } );
            setLatestNote( list[0] );
            setHasNote( true );
        } 
    }, [ obj.c, notes ] );

    // Latest Gift
    useEffect( () => {
        setLatestGift( {} );
        setHasGift( false );

        let list = [];
        Object.keys( gifts ).forEach( g => {
            const yes = gifts[g]?.recips?.find( f => f && f.cid === obj.c.cid );
            if ( yes ) {
                list.push( gifts[g] );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                const ad = new Date( a.giftDate );
                const bd = new Date( b.giftDate );

                return ( bd.getTime() - ad.getTime() );
            } );
            setLatestGift( list[0] );
            setHasGift( true );
        } 
    }, [ obj.c, gifts ] );

    // Latest Review
    useEffect( () => {
        setLatestReview( {} );
        setHasReview( false );

        let list = [];
        Object.keys( reviews ).forEach( r => {
            const yes = reviews[r]?.assoc?.find( f => f && f.cid === obj.c.cid );
            if ( yes ) {
                list.push( reviews[r] );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                const ad = new Date( a.reviewDate );
                const bd = new Date( b.reviewDate );

                return ( bd.getTime() - ad.getTime() );
            } );
            setLatestReview( list[0] );
            setHasReview( true );
        } 
    }, [ obj.c, reviews ] );

    // Latest Task
    useEffect( () => {
        setLatestTask( {} );
        setHasTask( false );

        let list = [];
        Object.keys( tasks ).forEach( t => {
            const yes = tasks[t]?.assoc?.find( f => f && f.cid === obj.c.cid );
            if ( yes ) {
                list.push( tasks[t] );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                const ad = new Date( a.createdDate );
                const bd = new Date( b.createdDate );

                return ( bd.getTime() - ad.getTime() );
            } );
            setLatestTask( list[0] );
            setHasTask( true );
        } 
    }, [ obj.c, tasks ] );

    // Latest Loan
    useEffect( () => {
        setLatestLoan( {} );
        setHasLoan( false );

        let list = [];
        Object.keys( loans ).forEach( l => {
            const yes = loans[l]?.borrowers?.find( f => f && f.cid === obj.c.cid );
            if ( yes ) {
                list.push( loans[l] );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                const ad = new Date( a.createdDate );
                const bd = new Date( b.createdDate );

                return ( bd.getTime() - ad.getTime() );
            } );
            setLatestLoan( list[0] );
            setHasLoan( true );
        } 
    }, [ obj.c, loans ] );

    // Latest Opp
    useEffect( () => {
        setLatestOpp( {} );
        setHasOpp( false );

        let list = [];
        Object.keys( opps ).forEach( o => {
            const yes = opps[o]?.relationships?.find( f => f && f.cid === obj.c.cid );
            if ( yes ) {
                list.push( opps[o] );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                const ad = new Date( a.oppDate );
                const bd = new Date( b.oppDate );

                return ( bd.getTime() - ad.getTime() );
            } );
            setLatestOpp( list[0] );
            setHasOpp( true );
        } 
    }, [ obj.c, opps ] );


    return (
        <Container fluid>
            <Row className='tf-contact-cv-name-container py-2 align-items-center' ref={titleRef}>
                <Col className='fs-4' xs='auto'>
                    <CallIcon />
                    <span className='ps-3 fw-bold'>{obj.reason}</span>
                </Col>
                <Col className='text-end'>
                    <Dropdown as={ButtonGroup}>
                        <Button className='tf-obj-button' size='sm' onClick={ () => handleSingleModal( 'log-call' ) }>Log a Call</Button>
                        <Button className='tf-obj-button' size='sm' onClick={ () => handleSingleModal( 'log-sms' ) }>Log a Txt</Button>
                        <Button className='tf-obj-button' size='sm' onClick={ () => handleSingleModal( 'log-email' ) }>Log an Email</Button>
                    </Dropdown>
                </Col>
            </Row>
            <Row className='overflow-scroll' style={ { height: `calc(100vh - 125px - ${titleHeight}px)` } }>
                <Col>
                    <Row className='py-2'>
                        <Col className='col-md-auto'>
                            <Row><Col className='fs-8'>Contact</Col></Row>
                            <Row><Col className='fs-7 fw-semibold'><Link to={`/contact/${obj.c.cid}`}>{obj.c.name}</Link></Col></Row>
                        </Col>
                        {
                            phones.map( ( p, idx ) => {
                                if ( obj.c[p.db] && obj.c[p.db].length ) {
                                    return (
                                        <Col key={`call-phone-${p.db}`} className='col-md-auto'>
                                            <Row><Col className='fs-8'>{p.label}</Col></Row>
                                            <Row><Col className='fs-7 fw-semibold'>{obj.c[p.db]}</Col></Row>
                                        </Col>
                                    );
                                }
                                return null;
                            } )
                        }
                    </Row>
                    <Row className='py-3'>
                        <Col className='tf-section-subtitle'>Call Details</Col>
                    </Row>
                    <Row className='py-2'>
                        <Col dangerouslySetInnerHTML={ { __html: obj.details } } />
                    </Row>
                    {
                        quicklinks.length ? (
                            <Fragment>
                                <Row className='py-3'>
                                    <Col className='tf-section-subtitle'>Quicklinks</Col>
                                </Row>
                                <Row className='py-2'>
                                {
                                    quicklinks.map( ( q ) => {
                                        if ( obj.c[q.db] && obj.c[q.db].length ) {
                                            return (
                                                <Col key={`call-ql-${q.db}`} className='col-md-auto'>
                                                    <Row><Col className='fs-8'>{q.label}</Col></Row>
                                                    <Row><Col className='fs-7 fw-semibold'><a href={obj.c[q.db]} target='_blank' rel='noreferrer'>{obj.c[q.db]}</a></Col></Row>
                                                </Col>
                                            );
                                        }
                                        return null;
                                    } )
                                }
                                </Row>
                            </Fragment>
                        ) : (
                            null
                        )
                    }
                    <Row className='py-3'>
                        <Col className='tf-section-subtitle'>Latest...</Col>
                    </Row>
                    <Row className='py-2'>
                        <Col className='mx-2'>
                            <Row className='tf-box-shadow align-items-center'>
                                <Col className='col-md-auto tf-call-latest-cat'>Lead Opportunity:</Col>
                                <Col className='col-md-auto'>
                                    {
                                        hasOpp ? (
                                            <Row className='align-items-center'>
                                                <Col>
                                                    <Row className='align-items-center'>
                                                        <Col xs='auto' className='tf-sidebar-obj-value'>
                                                            {latestOpp.status}
                                                        </Col>
                                                        <Col xs='auto' className='p-1 ps-3'>
                                                            {latestOpp.name}
                                                        </Col>
                                                        <Col xs='auto' className='p-1 ps-3'>
                                                            { formatDate( latestOpp.oppDate ) }
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Fragment>No opps yet</Fragment>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='py-2'>
                        <Col className='mx-2'>
                            <Row className='tf-box-shadow align-items-center'>
                                <Col className='col-md-auto tf-call-latest-cat'>Loan:</Col>
                                <Col className='col-md-auto'>
                                    {
                                        hasLoan ? (
                                            <Row className='align-items-center'>
                                                <Col>
                                                    <Row className='align-items-center'>
                                                        <Col xs='auto' className='tf-sidebar-obj-value'>
                                                            {latestLoan.status}
                                                        </Col>
                                                        <Col>
                                                            <Row>
                                                                <Col xs='auto' className='p-1 ps-3 pb-0'>
                                                                    {latestLoan.name}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs='auto' className='p-1 ps-3 pt-0'>
                                                                    {latestLoan.amount}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Fragment>No loans yet</Fragment>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='py-2'>
                        <Col className='mx-2'>
                            <Row className='tf-box-shadow align-items-center'>
                                <Col className='col-md-auto tf-call-latest-cat'>Task:</Col>
                                <Col className='col-md-auto'>
                                    {
                                        hasTask ? (
                                            <Row className='align-items-center'>
                                                <Col>
                                                    <Row className='align-items-center'>
                                                        <Col xs='auto' className='tf-sidebar-obj-value'>
                                                            {latestTask.type}
                                                        </Col>
                                                        <Col>
                                                            <Row>
                                                                <Col xs='auto' className='p-1 ps-3 pb-0'>
                                                                    {latestTask.name}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs='auto' className='p-1 ps-3 pt-0'>
                                                                    { formatDate( latestTask.dueDate ) }
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row className='overflow-scroll' style={ { maxHeight: '200px' } }>    
                                                        <Col dangerouslySetInnerHTML={ { __html: latestTask.details } } />
                                                    </Row>
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Fragment>No tasks have been created</Fragment>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='py-2 align-items-center'>
                        <Col className='mx-2'>
                            <Row className='tf-box-shadow align-items-center'>
                                <Col className='col-md-auto tf-call-latest-cat'>Comm:</Col>
                                <Col className='col-md-auto'>
                                    {
                                        hasComm ? (
                                            <Row className='align-items-center'>
                                                <Col>
                                                    <Row className='align-items-center'>
                                                        <Col xs='auto' className='tf-sidebar-obj-value'>
                                                            {latestComm.commType}
                                                        </Col>
                                                        <Col>
                                                            <Row>
                                                                <Col xs='auto' className='p-1 ps-3 pb-0'>
                                                                    {latestComm.name}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs='auto' className='p-1 ps-3 pt-0'>
                                                                    { formatDate( latestComm.commDate ) }
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row className='overflow-scroll' style={ { maxHeight: '200px' } }>    
                                                        <Col dangerouslySetInnerHTML={ { __html: latestNote.details } } />
                                                    </Row>
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Fragment>No comms have been saved</Fragment>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='py-2 align-items-center'>
                        <Col className='mx-2'>
                            <Row className='tf-box-shadow align-items-center'>
                                <Col className='col-md-auto tf-call-latest-cat'>Note:</Col>
                                <Col className='col-md-auto'>
                                    {
                                        hasNote ? (
                                            <Row className='align-items-center'>
                                                <Col>
                                                    <Row className='align-items-center'>
                                                        <Col xs='auto' className='tf-sidebar-obj-value'>
                                                            { formatDate( latestNote.createdDate ) }
                                                        </Col>
                                                        <Col>
                                                            <Row>
                                                                <Col xs='auto' className='p-1 ps-3 pb-0'>
                                                                    <Link to={`/note/${latestNote.nid}`}>{latestNote.name}</Link>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs='auto' className='p-1 ps-3 pt-0'>
                                                                    { latestNote.createdBy }
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row className='overflow-scroll' style={ { maxHeight: '200px' } }>    
                                                        {
                                                            ( latestNote.video ) ? (
                                                                <Col className='pt-2'>
                                                                    <video src={`https://tf-media.s3.amazonaws.com/${aid}/${latestNote.mediaUrl}`} controls playsInline style={ { height: '180px' } }></video>
                                                                </Col>
                                                            ) : ( latestNote.audio ) ? (
                                                                <Col className='pt-2'>
                                                                    <audio src={`https://tf-media.s3.amazonaws.com/${aid}/${latestNote.mediaUrl}`} controls playsInline></audio>
                                                                </Col>
                                                            ) : (
                                                                <Col dangerouslySetInnerHTML={ { __html: latestNote.details } } />
                                                            )
                                                        }
                                                    </Row>
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Fragment>No notes have been saved</Fragment>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='py-2 align-items-center'>
                        <Col className='mx-2'>
                            <Row className='tf-box-shadow align-items-center'>
                                <Col className='col-md-auto tf-call-latest-cat'>Gift:</Col>
                                <Col className='col-md-auto'>
                                    {
                                        hasGift ? (
                                            <Row className='align-items-center'>
                                                <Col xs='auto' className='tf-sidebar-obj-value'>
                                                    {latestGift.reason}
                                                </Col>
                                                <Col>
                                                    <Row className='align-items-center'>
                                                        <Col xs='auto' className='tf-sidebar-obj-key-date-container pe-1'>
                                                            <span className='tf-sidebar-obj-key-date'>
                                                                <Link to={`/gift/${latestGift.gid}`}>{latestGift.name}</Link>
                                                            </span>
                                                        </Col>
                                                        <Col xs='auto' className='p-0'><BsDot /></Col>
                                                        <Col xs='auto' className='p-1'>{latestGift.giftDate}</Col>
                                                        <Col xs='auto' className='p-0'><BsDot /></Col>
                                                        <Col xs='auto' className='p-1'>${latestGift.price}</Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Fragment>No gifts have been sent</Fragment>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='py-2 align-items-center'>
                        <Col className='mx-2'>
                            <Row className='tf-box-shadow align-items-center'>
                                <Col className='col-md-auto tf-call-latest-cat'>Review:</Col>
                                <Col className='col-md-auto'>
                                    {
                                        hasReview ? (
                                            <Row className='align-items-center'>
                                                <Col>
                                                    <Row className='align-items-center'>
                                                        <Col xs='auto'>
                                                            <Rating value={latestReview.rating} readOnly size='small' precision={0.5} />
                                                        </Col>
                                                        <Col className='ps-0'>
                                                            <Row className='align-items-center'>
                                                                <Col xs='auto' className='tf-sidebar-obj-key-date-container pe-1'>
                                                                    <Link to={`/review/${latestReview.rid}`}>{latestReview.headline}</Link>
                                                                </Col>
                                                                <Col xs='auto' className='p-0'><BsDot /></Col>
                                                                <Col xs='auto' className='p-1'>{latestReview.reviewDate}</Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row className='overflow-scroll' style={ { maxHeight: '50px' } }>
                                                        <Col>{latestReview.review}</Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Fragment>No reviews have been left</Fragment>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    meta: state.user.meta.contact.details,
    gifts: state.gifts.byId,
    tasks: state.tasks.byId,
    reviews: state.reviews.byId,
    comms: state.comms.byId,
    loans: state.loans.byId,
    notes: state.notes.byId,
    opps: state.leadopps.byId,
    gameplan: state.gameplan.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( Call );